__turbopack_context__.v({
  "background": "oN0D1G_background",
  "container": "oN0D1G_container",
  "events-playlist": "oN0D1G_events-playlist",
  "horizontal-playlist": "oN0D1G_horizontal-playlist",
  "ottHome": "oN0D1G_ottHome",
  "shimmer": "oN0D1G_shimmer",
  "slider": "oN0D1G_slider",
  "slider__loading": "oN0D1G_slider__loading",
  "text-bar-sweep": "oN0D1G_text-bar-sweep",
  "top-banner-playlist": "oN0D1G_top-banner-playlist",
  "wsc-playlist": "oN0D1G_wsc-playlist",
});
